import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertType } from '@app/shared/models/alert-type.model';


@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  isConfirmation: boolean;
  modalTitle: string;
  modalMessage: string;
  validateActionName: string;
  cancelActionName: string
  alertType: AlertType;

  information: string = AlertType.INFORMATION;
  confirmation: string = AlertType.CONFIRMATION;
  error: string = AlertType.ERROR;

  constructor(
    private dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.validateActionName = data.validateActionName;
    this.cancelActionName = data.cancelActionName;
    this.modalMessage = data.modalMessage;
    this.modalTitle = data.modalTitle
    this.alertType = data.alertType;
    this.isConfirmation = this.alertType == AlertType.CONFIRMATION;
  }

  onConfirm(confirmation: boolean) {
    this.dialogRef.close(confirmation);
  }
}
